import { IconButton } from '@trg/tlw-ui-component';
import { useMenuStore } from '../../../stores';
import { Favorite } from '../../actions/Favorite';
import { Member } from '../../actions/member/Member';

export function MenuMobileStatusBar() {
  const setMenuOpen = useMenuStore.use.setMenuOpen();
  const setSelectedCategory = useMenuStore.use.setSelectedCategory();

  const close = () => {
    setMenuOpen(false);
    setSelectedCategory(null);
  };

  return (
    <div className="tlw-h-16 tlw-px-5 tlw-py-2 tlw-flex tlw-justify-between tlw-items-center tlw-border-b tlw-border-b-sec-sup-light">
      <Member />

      <div className="tlw-flex tlw-items-center tlw-gap-4">
        <Favorite />

        <IconButton
          className="tlw-p-0"
          icon="X"
          iconSize={24}
          square
          onClick={close}
        />
      </div>
    </div>
  );
}
